<template>
  <div>
    <v-flex xs12 :class="!$vuetify.breakpoint.mdAndUp ? 'px-2 footer-text' : 'footer-text'">
      {{ $i18n.t('footerMessage') }}
    </v-flex>
    <v-menu offset-y v-if="log.length < 0">
      <template v-slot:activator="{ on }">
        <v-btn
            color="primary"
            dark
            v-on="on"
        >
          .
        </v-btn>
      </template>
      <v-list>
        <v-list-tile
            v-for="(item2, index2) in log"
            :key="index2"
            @click=""
        >
          <v-list-tile-title>{{ item2 }}</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import moment from 'moment'
import { createHelpers } from 'vuex-map-fields'
import state from './../state.js'

const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField'
})

export default {
  name: 'PageFooter',

  data () {
    return {
      originalWidth: window.innerWidth,
      log: [],
    }
  },

  created () {
    this.log.push(this.logTrigger)
  },

  watch: {
    logTrigger (value) {
      this.log.push(value)
    },
  },

  computed: {
    ...mapFields(Object.keys(state)),

    logTrigger () {
      if (this.log.length > 20) { return }
      return this.windowHeight + ' vs ' + this.windowWidth
    },

    yearNumber () {
      return moment().format('Y')
    },
  },
}
</script>

<style>
.footer-text {
  color: gray;
  padding: 10px;
}
@media screen and (max-width: 700px) {
  .footer-text {
    font-size: 11px;
  }
}
</style>
